<template>
  <svg
    width="22"
    height="18"
    viewBox="0 0 22 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.8329 10.25L10.7837 16.1093L9.02973 17.8907L0.000107589 8.99998L9.02973 0.109267L10.7837 1.89069L4.8329 7.74998L21.7817 7.74998L21.7817 10.25L4.8329 10.25Z"
      fill="white"
    />
  </svg>
</template>
